import { ColumnMode, SelectionType } from "@swimlane/ngx-datatable";
import { Component, HostListener, Input, OnInit, OnChanges } from "@angular/core";

import { MarketingConfigurationServices } from "src/app/_services/marketingConfiguration.service";
import { ConfirmComponent } from "src/app/dashboard/shared-components/confirm/confirm.component";
import { MainService } from "../../../../_services/mainService";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ToastrService } from "ngx-toastr";
import { TranslateService } from "@ngx-translate/core";
import { localStorageVal } from "src/app/_config/config";

/**
 *
 *
 * @export
 * @class RentalMarketingTableComponent
 * @implements {OnInit}
 */
@Component({
  selector: "app-rental-marketing-table",
  templateUrl: "./rental-marketing-table.component.html",
  styleUrls: ["./rental-marketing-table.component.scss"],
})
export class RentalMarketingTableComponent implements OnInit, OnChanges {
  loading = false;
  public showLoader = true;
  public dataList: any = [];
  public perPage = 10;
  public pageNumber = 1;
  public totalCount = 0;
  public page = 1;
  public selected = [];
  public SelectionType = SelectionType;
  public ColumnMode = ColumnMode;
  public screenWidth: number;
  public datatableResponsive = false;
  public reorderable = true;
  public loadingIndicator = true;
  public modalRefEdit: any;
  public maxNumber = 0;
  public totalPages = 0;
  public inputPage: any = "";
  closeResult: string;
  @Input() refreshList: boolean = false;
  public configurationData = null;

  public tenantId = localStorage.getItem(localStorageVal.tenantId);
  public marketingType: string = "RENTAL";

  /**
   * Creates an instance of RentalMarketingTableComponent.
   *
   * @param {MainService} mainService
   * @param {MarketingConfigurationServices} marketingConfigurationServices
   * @param {NgbModal} modal
   * @param {ToastrService} toastrService
   * @param {TranslateService} translate
   * @memberof RentalMarketingTableComponent
   */
  constructor(
    private mainService: MainService,
    private marketingConfigurationServices: MarketingConfigurationServices,
    public modal: NgbModal,
    public toastrService: ToastrService,
    public translate: TranslateService
  ) {
    this.onResize();
  }

  /**
   *
   *
   * @memberof RentalMarketingTableComponent
   */
  public queryParams: any = {
    perPage: this.perPage,
    pageNumber: this.pageNumber,
    sortKey: "",
    sortOrder: "",
    type: "RENTAL",
  };

  /**
   *
   *
   * @memberof RentalMarketingTableComponent
   */
  @HostListener("window:resize", ["$event"])
  onResize() {
    this.screenWidth = window.innerWidth;
    if (this.screenWidth <= 991) {
      this.datatableResponsive = true;
    } else {
      this.datatableResponsive = true;
    }
  }

  /**
   *
   *
   * @memberof RentalMarketingTableComponent
   */
  ngOnInit(): void {
    this.getMarketingConfigurations();
  }

  /**
   *
   *
   * @memberof RentalMarketingTableComponent
   */
  ngOnChanges() {
    if (this.refreshList) {
      this.getMarketingConfigurations();
    }
  }

  /**
   *
   *
   * @memberof RentalMarketingTableComponent
   */

  public getMarketingConfigurations() {
    const payload = this.mainService.convertObjectToQueryParams(
      this.queryParams
    );
    this.marketingConfigurationServices
      .getMarketingConfigurations(payload)
      .subscribe(
        (res) => {
          if (res.code === 200) {
            this.showLoader = false;
            this.dataList = res?.result?.rawData || [];
            this.totalCount = res?.result?.totalCount || 0;
            this.totalPages = Math.ceil(this.totalCount / this.perPage);
            this.maxNumber = Math.ceil(this.totalCount / this.perPage);
          }
        },
        (error) => {
          this.showLoader = false;
          this.toastrService.error(
            error.error?.message || this.translate.instant("errors.connectionError"),
            ""
          );
        }
      );
  }

  public filter(){};

  /**
   *
   *
   * @memberof RentalMarketingTableComponent
   */
  public downloadFile() {
    const queryParams = JSON.parse(JSON.stringify(this.queryParams));
    delete queryParams.perPage;
    delete queryParams.pageNumber;
    const payload = this.mainService.convertObjectToQueryParams(queryParams);
    this.marketingConfigurationServices
      .downloadMarketingConfigurations(payload)
      .subscribe(
        (response: Blob) => {
          const blob = new Blob([response], { type: "application/octet-stream" });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = `rental-marketing-configurations-${new Date().toISOString()}.csv`;
          link.click();
          window.URL.revokeObjectURL(url);
          link.remove();
        },
        (error) => {
          this.toastrService.error(
            error.error?.message || this.translate.instant("errors.connectionError"),
            ""
          );
        }
      );
  }

  /**
   *
   *
   * @param {({ name: string | number; value: any } | HTMLInputElement)} text
   * @memberof RentalMarketingTableComponent
   */
  public onSearch(text: { name: string | number; value: any } | HTMLInputElement | HTMLSelectElement) {
    // Handle both object format, HTMLInputElement, and HTMLSelectElement
    let fieldName: string;
    let value: any;
    
    if (text instanceof HTMLInputElement || text instanceof HTMLSelectElement) {
      fieldName = text.name;
      value = text.value || "";
    } else {
      fieldName = text.name as string;
      value = text.value || "";
    }
    
    // Handle date fields - convert to proper format if needed
    if ((fieldName === 'createdAt' || fieldName === 'updatedAt') && value) {
      // Date inputs return YYYY-MM-DD format, which should be fine for the API
      // But we might need to handle empty dates
      if (!value || value.trim() === '') {
        delete this.queryParams[fieldName];
        this.pageReset();
        this.getMarketingConfigurations();
        return;
      }
    }
    
    // Only set the parameter if there's a value, otherwise remove it
    if (value && value.toString().trim() !== '') {
      this.queryParams[fieldName] = value;
    } else {
      // Remove the parameter if empty
      delete this.queryParams[fieldName];
    }
    
    this.pageReset();
    this.getMarketingConfigurations();
  }

  /**
   *
   *
   * @param {number} page
   * @memberof RentalMarketingTableComponent
   */
  public loadPage(page: number) {
    this.showLoader = true;
    this.pageNumber = page;
    this.queryParams.pageNumber = page;
    this.getMarketingConfigurations();
  }

  /**
   *
   *
   * @param {*} page
   * @memberof RentalMarketingTableComponent
   */
  public onPageNumber(page: any) {
    if (parseInt(page.target.value) > this.maxNumber) {
      page.target.value = "";
    }
    this.inputPage = page.target.value;
    if (
      !isNaN(parseInt(page.target.value, 10)) &&
      parseInt(page.target.value, 10) !== 0
    ) {
      if (parseInt(page.target.value, 10) <= this.totalPages) {
        this.pageNumber = page.target.value;
      }
    }
  }

  /**
   *
   *
   * @param {*} addRentalMarketing
   * @param {*} configurationData
   * @memberof RentalMarketingTableComponent
   */
  addRentalMarketing(addRentalMarketing: any, configurationData: any) {
    this.configurationData = configurationData;
    this.open(addRentalMarketing);
  }

  /**
   *
   *
   * @param {*} content
   * @memberof RentalMarketingTableComponent
   */
  open(content: any) {
    this.modalRefEdit = this.modal.open(content, {
      ariaLabelledBy: "modal-basic-title",
      windowClass: "end-side-panel dark-modal-50rem",
    });
    // Subscribe to the modal's `result` observable to get data back from the child modal
    this.modalRefEdit.result.then(
      (result) => {
        // Handle data returned from the child modal here
      },
      (reason) => {
        // Handle modal dismissal (if needed)
        if (reason && reason.isSuccess) {
          this.getMarketingConfigurations();
        }
      }
    );
  }


  /**
   *
   *
   * @memberof RentalMarketingTableComponent
   */
  closeForm() {
    this.modalRefEdit.close();
  }

  /**
   *
   *
   * @param {*} event
   * @memberof RentalMarketingTableComponent
   */
  onSort(event: any) {
    this.queryParams.sortKey = event.sorts[0].prop;
    this.queryParams.sortOrder = event.sorts[0].dir;
    this.getMarketingConfigurations();
  }

  /**
   *
   *
   * @param {string} property
   * @returns
   * @memberof RentalMarketingTableComponent
   */
  onSearchValue(property: string) {
    return this.queryParams.hasOwnProperty(property)
      ? this.queryParams[property]
      : "";
  }

  /**
   *
   *
   * @memberof RentalMarketingTableComponent
   */
  pageReset() {
    this.pageNumber = 1;
    this.queryParams.pageNumber = this.pageNumber;
  }

  /**
   * Delete marketing configuration
   *
   * @param {*} row
   * @memberof RentalMarketingTableComponent
   */
  deleteMarketingConfiguration(row: any) {
    const modalRef = this.modal.open(ConfirmComponent, {
      scrollable: true,
      windowClass: "success-modal",
    });

    modalRef.componentInstance.fromParent = {
      head: "Delete Marketing Configuration?",
      content: "Are you sure you want to delete this marketing configuration? This action cannot be undone.",
    };

    modalRef.result.then(
      (result) => {
        if (result && result.isConfirm) {
          this.performDelete(row);
        }
      },
      () => {
        // User cancelled, do nothing
      }
    );
  }

  /**
   * Perform the actual delete operation
   *
   * @private
   * @param {*} row
   * @memberof RentalMarketingTableComponent
   */
  private performDelete(row: any) {
    this.loading = true;
    const marketingId = row.marketingId || row._id || row.id;
    
    this.marketingConfigurationServices.deleteMarketingConfiguration(marketingId).subscribe(
      (res: any) => {
        this.loading = false;
        if (res.code === 200 || res === true) {
          this.toastrService.success(
            this.translate.instant("Marketing configuration deleted successfully"),
            ""
          );
          this.getMarketingConfigurations();
        }
      },
      (error) => {
        this.loading = false;
        setTimeout(() => {
          if (!error.error?.message) {
            this.toastrService.error(
              this.translate.instant("errors.connectionError"),
              ""
            );
          } else {
            this.toastrService.error(error.error.message, "");
          }
        }, 1000);
      }
    );
  }
}

